<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">全部用户</h3>
        <div class="block-options">
          <button
            v-if="addBtn"
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
            @click="create('add')"
          >
            <i class="fa fa-plus mr-1"></i> 新增
          </button>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <div class="block-content-full">
        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
          <div class="row mb-1">
            <div class="col-12 col-md-4 text-center text-md-left">
              <pageSize @changePageSize="changePageSize"></pageSize>
            </div>
            <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
              <div class="dt-buttons">
                <button
                  class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  tabindex="0"
                  aria-controls="DataTables_Table_1"
                  data-clipboard-text
                  @click="copy()"
                  type="button"
                  id="copybtn"
                >
                  <span>复制</span>
                </button>
                <button
                  class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  @click="exportCSV()"
                  type="button"
                >
                  <span>导出</span>
                </button>
                <button
                  class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                  @click="print()"
                >
                  <span>打印</span>
                </button>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center text-md-right">
              <div class="dataTables_filter">
                <label>
                  <input
                    type="search"
                    class="form-control"
                    placeholder="搜索"
                    v-model="key"
                    @keyup.enter="search()"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <section ref="print">
                  <p class="show-on-print print-title">全部用户</p>
                  <table
                    id="example"
                    class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                  >
                    <thead>
                      <tr>
                        <th
                          class="text-center sorting"
                          style="width: 60px; min-width:60px"
                          @click="getList('CREATE_TIME',$event)"
                        >#</th>
                        <th
                          class="text-left sorting d-md-table-cell"
                          style="width:110px;min-width:110px;"
                          @click="getList('CARPORT_WHITE_TYPE',$event)"
                        >用户类型</th>
                        <th
                          class="text-left sorting d-md-table-cell"
                          style="width:100px;min-width:100px;"
                          @click="getList('USER_ID',$event)"
                        >用户ID</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          style="width:100px;min-width:100px;"
                          @click="getList('MOBILE_PHONE',$event)"
                        >手机号码</th>
                        <th
                          class="text-left sorting"
                          style="width: 95px;min-width: 95px;"
                          @click="getList('CARD_NO',$event)"
                        >实体卡号</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          style="width:120px;min-width:120px;"
                          @click="getList('BALANCE',$event)"
                        >钱包余额(元)</th>
                        <th
                          class="text-left d-xl-table-cell sorting"
                          style="width: 95px; min-width:95px"
                          @click="getList('TOTAL_NUM',$event)"
                        >订单数量</th>
                        <!-- <th
                          class="text-left d-xl-table-cell sorting"
                          style="width: 95px; min-width:95px"
                          @click="getList('INOUT_NUM',$event)"
                        >出入记录</th>-->
                        <th
                          class="text-left d-xl-table-cell sorting"
                          style="width:110px;min-width:110px;"
                          @click="getList('STOP_PACKAGE_NUM',$event)"
                        >用户时长包</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          style="width:140px;min-width:140px;"
                          @click="getList('CREATE_TIME',$event)"
                        >首次登录时间</th>
                        <!-- <th
                          class="text-center sorting d-xl-table-cell"
                          style="width:95px;min-width:95px;"
                          @click="getList(' ',$event)"
                        >实名认证</th>-->

                        <!-- 2020.1.15去除
                        <th
                          class="text-center sorting d-xl-table-cell"
                          style="width:95px;min-width:95px;"
                          @click="getList('STATE',$event)"
                        >用户状态</th>-->
                        <th
                          class="text-center d-xl-table-cell no-print"
                          style="width: 100px; min-width:100px"
                        >操作</th>
                      </tr>
                    </thead>
                    <tbody v-if="userList.length">
                      <tr v-for="(item, i) in userList" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-left">{{ item.CARPORT_WHITE_TYPE == 1 ? '白名单' : '普通' }}</td>
                        <td
                          class="text-left d-xl-table-cell"
                          style="min-width:80px;"
                        >{{ item.USER_ID }}</td>
                        <td
                          class="text-left d-xl-table-cell"
                          style="min-width:80px;"
                        >{{ item.MOBILE_PHONE }}</td>
                        <td class="text-left d-xl-table-cell">
                          {{ item.CARD_NO }}
                          <!-- <a
                            href="javascrpit:void(0)"
                            data-toggle="modal"
                            @click="create('card',item.USER_ID)"
                          >{{ item.CARD_NO }}</a>-->
                        </td>
                        <td class="text-left d-xl-table-cell">{{ changeTwoDecimal(item.BALANCE) }}</td>
                        <td class="text-left d-xl-table-cell">{{ item.TOTAL_NUM}}</td>
                        <!-- <td class="text-left d-xl-table-cell">{{ item.INOUT_NUM }}</td> -->
                        <td class="text-left d-xl-table-cell">{{ item.STOP_PACKAGE_NUM }}</td>
                        <td class="text-left">{{ item.CREATE_TIME || '' }}</td>
                        <!-- <td class="text-left">
                          <a
                            href="javascrpit:void(0)"
                            data-toggle="modal"
                            @click="create('car',item)"
                          >{{ item.CAR_TYPE_NAME }}</a>
                        </td>-->

                        <!-- <td class="text-center d-xl-table-cell" style="min-width:80px;">
                          <span
                            class="badge badge-pill"
                            :class="{'badge-success':item.STATE=='1','badge-secondary':item.STATE!='1','badge-danger':item.STATE!='1'}"
                          >{{item.STATE=="1"?"启用":item.STATE=="2"?"禁用":"未知"}}未认证/审核中/已认证</span>
                        </td>-->

                        <!-- 2020.1.15去除
                        <td class="text-center d-xl-table-cell" style="min-width:80px;">
                          <span
                            class="badge badge-pill"
                            :class="{'badge-success':item.STATE=='1','badge-secondary':item.STATE!='1'}"
                          >{{item.STATE=='1'?"启用":"禁用"}}</span>
                        </td>-->
                        <td class="text-center no-print">
                          <div class="btn-group">
                            <button
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              title="查看"
                              data-original-title="Edit"
                              @click="$router.push({name:'carportWhiteUser', params:{id:item.USER_ID,val:key,type:'see'}})"
                            >
                              <i class="fa fa-search"></i>
                            </button>
                            <button
                              v-if="editBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              title="编辑"
                              data-original-title="Edit"
                              @click="$router.push({name:'carportWhiteUser', params:{id:item.USER_ID,val:key,type:'carport'}})"
                            >
                              <i class="fa fa-pencil-alt"></i>
                            </button>
                            <!-- <button
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              title="退还时长"
                              data-original-title="Edit"
                              data-toggle="modal"
                              @click="create('returnTime',item.USER_ID)"
                            >
                              <i class="fa fa-history"></i>
                            </button>-->
                            <!-- 2020.1.15去除
                            <button
                              v-if="stateBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              title="修改状态"
                              data-original-title="Edit"
                              data-toggle="modal"
                              @click="createSet(item)"
                            >
                              <i class="fa fa-user-cog"></i>
                            </button>-->
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="14">查无数据</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
              <div class="dataTables_info" role="status" aria-live="polite">
                页数
                <strong>{{ page }}</strong> /
                <strong>{{ totalPage }}</strong>
              </div>
            </div>
            <div class="col-sm-12 col-md-7 text-center text-md-right">
              <div class="dataTables_paginate paging_full_numbers">
                <el-pagination
                  v-if="userList && userList.length"
                  @current-change="handleCurrentChange"
                  :current-page="page"
                  :page-size="pageSize"
                  :small="isMobile"
                  :pager-count="pagerCount"
                  :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                  :total="total"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <div
      class="modal fade"
      id="modal-default-normal-add"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">新增用户</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  新增方式
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.type">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in addTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  手机号码
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.mobilePhone"
                    maxlength="11"
                    :disabled="form.type!='1'&&form.type!='2'"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  实体卡号
                  <span class="input-required" v-if="form.type == 2">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.userCard"
                    :disabled="form.type!='2'"
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-sm btn-primary btn-sm-h" @click="submit()">保存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 实体卡、车辆信息、退余额、退时长 -->
    <div
      class="modal fade"
      id="modal-default-normal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
            >{{edit=='card'?"卡片信息":(edit=='car'?"绑定车辆":(edit=="refund"?"用户信息":"退还时长"))}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <!-- 点击实体卡 -->
              <div class="form-group form-group-50" v-show="edit=='card'">
                <label class="col-sm-12 control-label">实体卡号</label>
                <div class="col-sm-12">
                  <input v-model="cardNo" type="text" class="form-control" disabled />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='card'">
                <label class="col-sm-12 control-label">卡片状态</label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="state" disabled>
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cardType"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <!-- 点击车辆信息 -->
              <div class="form-group form-group-50" v-show="edit=='car'">
                <label class="col-sm-12 control-label">车辆类型</label>
                <div class="col-sm-12">
                  <input disabled type="text" class="form-control" v-model="carType" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='car'">
                <label class="col-sm-12 control-label">车牌号码</label>
                <div class="col-sm-12">
                  <input disabled type="text" class="form-control" v-model="plateNumber" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='car'">
                <label class="col-sm-12 control-label">车辆品牌</label>
                <div class="col-sm-12">
                  <input disabled type="text" class="form-control" v-model="brand" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='car'">
                <label class="col-sm-12 control-label">车辆型号</label>
                <div class="col-sm-12">
                  <input disabled type="text" class="form-control" v-model="model" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='car'">
                <label class="col-sm-12 control-label">车辆图片</label>
                <div class="col-sm-12">
                  <img :src="imgStr" class="dz-image-120" />
                </div>
              </div>
              <!-- 修改余额 -->
              <div class="form-group" v-show="edit=='refund'">
                <label class="col-sm-12 control-label">用户ID</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" disabled v-model="form.userId" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='refund'">
                <label class="col-sm-12 control-label">手机号码</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.mobilePhone" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='refund'">
                <label class="col-sm-12 control-label">实体卡号</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.userCard" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='refund'">
                <label class="col-sm-12 control-label">钱包余额(元)</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" disabled v-model="money" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='refund'">
                <label class="col-sm-12 control-label">修改余额(元)</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.balanceMoney"
                    maxlength="9"
                    @input="changeInput()"
                  />
                </div>
              </div>
              <!-- 退时长 -->
              <div class v-show="edit=='returnTime'">
                <label class="col-sm-12 control-label">
                  订单号
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    v-model="form.packageOrderId"
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    @change="getpackgeMessage()"
                  >
                    <el-option
                      v-for="item in packageList"
                      :key="item.ID"
                      :label="item.PACKAGE_ORDER_ID"
                      :value="item.PACKAGE_ORDER_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='returnTime'">
                <label class="col-sm-12 control-label">时间</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control"
                    name="example-flatpickr-default"
                    v-model="createTime"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='returnTime'">
                <label class="col-sm-12 control-label">类型</label>
                <div class="col-sm-12">
                  <select class="form-control" disabled v-model="packageType">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in timeType"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='returnTime'">
                <label class="col-sm-12 control-label">名称</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" disabled v-model="description" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='returnTime'">
                <label class="col-sm-12 control-label">价格(元)</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" disabled v-model="payMoney" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='returnTime'">
                <label class="col-sm-12 control-label">适用范围</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" disabled v-model="cellName" />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='returnTime'">
                <label class="col-sm-12 control-label">开始时间</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control"
                    name="example-flatpickr-default"
                    v-model="startTime"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='returnTime'">
                <label class="col-sm-12 control-label">到期时间</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white"
                    name="example-flatpickr-default"
                    v-model="form.expiredTime"
                  />
                </div>
              </div>
              <div class="form-group form-group-50" v-show="edit=='returnTime'">
                <label class="col-sm-12 control-label">
                  剩余分钟数
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.remain" />
                </div>
              </div>
              <!-- <div class="form-group" v-show="edit=='returnTime'">
                <label class="col-sm-12 control-label">备注</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.remark" />
                </div>
              </div>-->
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              v-if="edit=='refund' || edit=='returnTime'"
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit()"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import screenTime from "../../../components/screenTime";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      userList: [],
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      edit: "",
      walletlList: [],
      timePackageList: [],
      chargeList: [],
      packageList: [],
      rechargeList: [],
      totalModal: 1,
      pageModal: 1,
      form: {
        refundMoney: "",
        userId: "",
        remark: "",
        packageOrderId: "",
        remain: "",
        expiredTime: "",
        mobilePhone: "",
        userCard: "",
        state: "",
        balanceMoney: "",
        type: ""
      },
      createTime: "",
      packageType: "",
      description: "",
      payMoney: "",
      cellName: "",
      startTime: "",
      money: "",
      state: "",
      cardNo: "",
      carType: "",
      plateNumber: "",
      brand: "",
      model: "",
      imgStr: "",
      cardType: [
        {
          value: "1",
          label: "启用"
        },
        {
          value: "2",
          label: "禁用"
        },
        {
          value: "3",
          label: "挂失"
        }
      ],
      carTypeList: [
        {
          value: "1",
          label: "自行车"
        },
        {
          value: "2",
          label: "摩托车"
        }
      ],
      timeType: [
        {
          value: "1",
          label: "普通"
        },
        {
          value: "2",
          label: "月底清零"
        }
      ],
      addTypeList: [
        {
          value: "1",
          label: "手机号码"
        },
        {
          value: "2",
          label: "手机号码 + 实体卡号"
        }
      ],
      userNum: {},
      newUserArr: [],
      buyUserArr: [],
      totalUserArr: [],
      arpuIncomeArr: [],
      clipboard: null,
      sorting: "",
      orderBy: false,
      editBtn:
        Util.isHavePerm("white/addWhiteModel") ||
        Util.isHavePerm("user/updateUserInfo") ||
        Util.isHavePerm("white/deleteWhiteModel"),
      retimeBtn: Util.isHavePerm("userRefund/userDurationRefund"),
      stateBtn: Util.isHavePerm("user/updateOrdinaryUserState"),
      addBtn: Util.isHavePerm("user/insertOrdinaryUser")
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    totalPageModal() {
      if (this.totalModal == 0) {
        return 0;
      } else {
        return Math.ceil(this.totalModal / 10, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    searchKye() {
      return this.$store.state.searchKye;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key() {
      if (this.key.length == 0 || this.searchKye) {
        this.getList();
      }
    },
    "form.mobilePhone"(val, oldVal) {
      this.form.mobilePhone = Util.isNumber(val);
    },
    "form.userCard"(val, oldVal) {
      this.form.userCard = Util.isNumber(val);
    },
    "form.balanceMoney"(val, oldVal) {
      this.form.balanceMoney = Util.testNumberFn(val, "inputChangeTwoDecimal");
    },
    "form.type"(val, oldVal) {
      if (val == "1") {
        this.form.userCard = "";
      }
    }
  },
  mounted() {
    if (this.params.val) {
      this.key = this.searchKye;
    }
    this.getList();
    this.copy();
    // this.getUserNum();
  },
  methods: {
    getUserNum() {
      this.$http
        .get(
          `${Util.searchURL}/Carport/GetUserInfo/${this.duration.startDate}/${this.duration.endDate}?region=${this.regionParams.region}&object=${this.regionParams.object}`
        )
        .then(res => {
          if (res.data.code === 200) {
            this.userNum = res.data.data;
            this.newUserArr = [];
            this.buyUserArr = [];
            this.totalUserArr = [];
            this.arpuIncomeArr = [];
            if (res.data.data) {
              let log = res.data.data.log;
              log.find(d => {
                this.newUserArr.push(Number(d.newUserNum));
                this.buyUserArr.push(Number(d.buyUserNum));
                this.totalUserArr.push(Number(d.totalUserNum));
                this.arpuIncomeArr.push(Number(d.arpuIncomeNum));
              });
              // $(function() {
              //   Dashmix.helpers([
              //     "easy-pie-chart",
              //     "sparkline",
              //     "datepicker",
              //     "flatpickr"
              //   ]);
              // });
            }
          }
        });
    },
    changeInput() {
      this.form.refundMoney = Util.testNumberFn(
        this.form.refundMoney,
        "inputChangeTwoDecimal"
      );
      // 数据改变，视图不改变时，重新编译对象
      this.form = Object.assign({}, this.form);
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changePage(val) {
      this.page = val;
    },
    createSet(val) {
      this.form.userId = val.USER_ID;
      this.form.state = val.STATE == 1 ? 2 : 1;
      let text = this.form.state == 2 ? "确定禁用？" : "确定启用？";
      swal(text, {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.switchChange();
            break;
        }
      });
    },
    switchChange() {
      this.$http
        .post(`${Util.operateURL}/user/updateOrdinaryUserState`, this.form)
        .then(res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        }),
        err => {
          console.log(err);
        };
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Carport/UserManagerList/${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.userList = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
            // setTimeout(() => {
            //   $('#example').DataTable( {
            //     scrollX: true,
            //     fixedColumns: {
            //       rightColumns: 1
            //     }
            //   });
            // }, 500);
          }
        });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/UserManagerList/${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    search() {
      this.page = 1;
      this.getList();
    },
    create(val, id) {
      this.edit = val;
      this.pageModal = 1;
      this.form = {};
      if (val == "add") {
        jQuery("#modal-default-normal-add").modal("show");
        this.form = {
          mobilePhone: "",
          userCard: "",
          type: ""
        };
      } else if (val == "card") {
        jQuery("#modal-default-normal").modal("show");
        this.getCard(id);
      } else if (val == "car") {
        jQuery("#modal-default-normal").modal("show");
        this.getCar(id.USER_ID);
        this.carType = id.CAR_TYPE_NAME;
      } else if (val == "refund") {
        jQuery("#modal-default-normal").modal("show");
        this.money = Util.changeTwoDecimal(id.BALANCE);
        this.form = {
          userId: id.USER_ID,
          mobilePhone: id.MOBILE_PHONE,
          userCard: id.CARD_NO,
          balanceMoney: ""
        };
      } else if (val == "returnTime") {
        jQuery("#modal-default-normal").modal("show");
        this.timePackageId = id;
        this.getReturnTimeList(id);
        this.createTime = "";
        this.packageType = "";
        this.description = "";
        this.payMoney = "";
        this.cellName = "";
        this.startTime = "";
        this.form.expiredTime = "";
        this.form.remain = "";
        this.form.remark = "";
      }
    },
    getReturnTimeList(val) {
      this.$http
        .get(`${Util.searchURL}/User/GetUserPackageOrder/${val}`)
        .then(res => {
          if (res.data.code === 200) {
            this.packageList = res.data.data;
          }
        });
    },
    getpackgeMessage() {
      this.$http
        .get(
          `${Util.searchURL}/User/GetPackageById/${this.form.packageOrderId}`
        )
        .then(res => {
          if (res.data.code == 200) {
            this.createTime = new Date(res.data.data.CREATE_TIME).Format(
              "yyyy-MM-dd"
            );
            this.packageType = res.data.data.PACKAGE_TYPE;
            this.description = res.data.data.DESCRIPTION;
            this.payMoney = Util.changeTwoDecimal(res.data.data.PAY_MONEY);
            this.cellName = res.data.data.CELL_NAME;
            this.startTime = new Date(res.data.data.START_TIME).Format(
              "yyyy-MM-dd"
            );
            this.form.expiredTime = new Date(res.data.data.EXPIRED_TIME).Format(
              "yyyy-MM-dd"
            );
            this.form.remain = res.data.data.REMAIN_MINUTE;
            this.form.remark = res.data.data.PACKAGE_REMARK;
          }
        });
    },
    getCard(val) {
      this.$http.get(`${Util.searchURL}/User/GetUserCard/${val}`).then(res => {
        if (res.data.code === 200) {
          this.cardNo = res.data.data.CARD_NO;
          this.state = res.data.data.STATE;
        }
      });
    },
    getCar(val) {
      this.$http
        .get(`${Util.searchURL}/User/GetUserVehicle/${val}`)
        .then(res => {
          if (res.data.code === 200) {
            this.imgStr = res.data.data.THUMBNAIL_URL;
            this.plateNumber = res.data.data.PLATE_NUMBER;
            this.brand = res.data.data.BRAND;
            this.model = res.data.data.MODEL;
          }
        });
    },
    submit() {
      let url = "";
      if (this.edit == "refund") {
        url = `${Util.operateURL}/user/updateUserInfo`;
      } else if (this.edit == "add") {
        url = `${Util.operateURL}/user/insertOrdinaryUser`;
      } else {
        url = `${Util.operateURL}/userRefund/userDurationRefund`;
        if (!this.form.packageOrderId) {
          Util.message("war", "请选择订单号");
          return;
        }
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code == 200) {
            Util.message("succ", res.data.desc);
            jQuery("#modal-default-normal").modal("hide");
            jQuery("#modal-default-normal-add").modal("hide");

            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    showEffective(str) {
      switch (str) {
        case "0":
          return "已过期";
        case "1":
          return "使用中";
        case "2":
          return "待生效";
      }
    },
    showState(str) {
      switch (str) {
        case "0":
          return "有效";
        case "1":
          return "无效";
      }
    },
    showWay(str) {
      switch (str) {
        case "0":
          return "微信支付";
        case "1":
          return "余额支付";
        case "2":
          return "押金抵扣";
      }
    }
  }
};
</script>